"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiElement = exports.KPIElementSize = exports.KPIElementColor = void 0;
const icons_1 = require("client/components/icons");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./kpi-element.less");
var KPIElementColor;
(function (KPIElementColor) {
    KPIElementColor["Aqua"] = "aqua";
    KPIElementColor["Green"] = "green";
    KPIElementColor["LightGreen"] = "light green";
    KPIElementColor["Grey"] = "grey";
    KPIElementColor["Red"] = "red";
    KPIElementColor["LightRed"] = "lightred";
    KPIElementColor["Yellow"] = "yellow";
    KPIElementColor["Blue"] = "blue";
})(KPIElementColor = exports.KPIElementColor || (exports.KPIElementColor = {}));
var KPIElementSize;
(function (KPIElementSize) {
    KPIElementSize["Small"] = "small";
    KPIElementSize["Medium"] = "medium";
    KPIElementSize["Large"] = "large";
})(KPIElementSize = exports.KPIElementSize || (exports.KPIElementSize = {}));
let KpiElement = class KpiElement extends react_1.Component {
    render() {
        const { check = false, element = {
            color: KPIElementColor.Grey,
            label: "",
            size: KPIElementSize.Small,
            value: 0
        }, faded = false } = this.props;
        const checkColor = check ? "aqua" : element.color;
        const colorClass = faded
            ? ` kpi-element__faded-${checkColor}`
            : ` kpi-element__${checkColor}`;
        let className = "kpi-element";
        if (this.props.onClickElement) {
            className += " clickable";
        }
        return (React.createElement("div", { className: className, onClick: () => this.props.onClickElement && this.props.onClickElement(element) },
            React.createElement("div", { className: `kpi-element__circle kpi-element__${element.size}${colorClass}` },
                React.createElement("div", { className: "kpi-element__child" }, check ? React.createElement(icons_1.CheckmarkIcon, { fill: "#fff" }) : element.value)),
            React.createElement("div", { className: `kpi-element__${element.size}-label` }, element.label)));
    }
};
KpiElement = __decorate([
    mobx_react_1.observer
], KpiElement);
exports.KpiElement = KpiElement;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-element/kpi-element.tsx
// module id = 3344
// module chunks = 0